import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2" }

import NotificationSettingRow from '@/components/AccountParts/NotificationSettingRow.vue';
import AccountNotificationSettingsType from '@/types/AccountNotificationSettings';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import { computed, ref, onMounted } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationSettings',
  props: {
    modelValue: {},
    outputDataAuthority: { type: Boolean },
    temperatureAuthority: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props;

const isAll = ref(false)

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

onMounted(() => {
  checkAllStatuses();
});

function changeAllStatus(bool: boolean) {
  Object.keys(modelValue.value).forEach((key: string) => {
    Object.keys(modelValue.value[key]).forEach((setting: string) => {
      modelValue.value[key][setting] = bool;
    });
  });
}

function checkAllStatuses() {
  let isAllStatusesTrue = true;
  Object.keys(modelValue.value).forEach((key: string) => {
    Object.keys(modelValue.value[key]).forEach((setting: string) => {
      if (!modelValue.value[key][setting]) {
        isAllStatusesTrue = false;
      }
    });
  });
  isAll.value = isAllStatusesTrue;
}

function clickToggleSwitch(bool: boolean) {
  changeAllStatus(bool)
}


return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "text-form px-3 pt-4 d-flex" }, {
      default: _withCtx(() => [
        _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.accounts.form.notificationSettings.all')), 1),
        _createVNode(ToggleSwitch, {
          class: "ml-6",
          modelValue: isAll.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAll).value = $event)),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (clickToggleSwitch(!isAll.value)))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(NotificationSettingRow, {
      title: _unref(i18n).global.t('pages.accounts.form.notificationSettings.riskyDriving.title'),
      keyName: 'riskyDriving',
      modelValue: modelValue.value.riskyDriving,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.riskyDriving) = $event)),
      onChange: checkAllStatuses
    }, null, 8, ["title", "modelValue"]),
    _createVNode(NotificationSettingRow, {
      title: _unref(i18n).global.t('pages.accounts.form.notificationSettings.cvrUpload.title'),
      keyName: 'cvrUpload',
      modelValue: modelValue.value.cvrUpload,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.cvrUpload) = $event)),
      onChange: checkAllStatuses
    }, null, 8, ["title", "modelValue"]),
    (props.temperatureAuthority)
      ? (_openBlock(), _createBlock(NotificationSettingRow, {
          key: 0,
          title: _unref(i18n).global.t('pages.accounts.form.notificationSettings.temperature.title'),
          keyName: 'temperature',
          modelValue: modelValue.value.temperature,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue.value.temperature) = $event)),
          onChange: checkAllStatuses
        }, null, 8, ["title", "modelValue"]))
      : _createCommentVNode("", true),
    (props.outputDataAuthority)
      ? (_openBlock(), _createBlock(NotificationSettingRow, {
          key: 1,
          title: _unref(i18n).global.t('pages.accounts.form.notificationSettings.outputData.title'),
          keyName: 'outputData',
          modelValue: modelValue.value.outputData,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modelValue.value.outputData) = $event)),
          onChange: checkAllStatuses
        }, null, 8, ["title", "modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})